import React from 'react'
import CommunityPostsListing from './CommunityPostsListing'

const CommunityWinner = () => (
  <CommunityPostsListing
    postType="winner"
    title="Winner Posts"
    subtitle="The overall competition winner announced to your community."
  />
)

export default CommunityWinner
